import LinkedField from "../singleton/linked-field";
import FieldPromote from "../singleton/field-promote";
import Field from "../singleton/field";

export default {

    Promote: {

        toBasic: FieldPromote.toBasic.bind(FieldPromote),

        toDatetime: FieldPromote.toDatetime.bind(FieldPromote),

        toPhone: FieldPromote.toPhone.bind(FieldPromote),

        toNumber: FieldPromote.toNumber.bind(FieldPromote),

        toLinked: FieldPromote.toLinked.bind(FieldPromote),

        toLookup: FieldPromote.toLookup.bind(FieldPromote),

        toFormula: FieldPromote.toFormula.bind(FieldPromote)

    },

    Linked: {

        getOptions: LinkedField.getOptions.bind(LinkedField),

        getFilterOptions: LinkedField.getFilterOptions.bind(LinkedField)

    },

    get: Field.get.bind(Field),

    create: Field.create.bind(Field),

    delete: Field.delete.bind(Field),

    rename: Field.rename.bind(Field),

    getRelatedFields: Field.getRelatedFields.bind(Field),

    getLookupOptions: Field.getLookupOptions.bind(Field),

    getTypeReferenced: Field.getTypeReferenced.bind(Field),

    getDefaultValueOptions: Field.getDefaultValueOptions.bind(Field),

    getDefaultValue: Field.getDefaultValue.bind(Field),

    setDefaultValue: Field.setDefaultValue.bind(Field)

}